'use strict';

app.directive('rmAudio', function ($window, $interval, $timeout) {
  return {
    scope: {
      url: '=rmAudio'
    },
    templateUrl: '/app/directives/rm-audio/rm-audio.html',
    link: function (scope, element) {

      var audio;

      scope.$watch('url', function (url) {
        scope.canplay = false;
        scope.timer = '';
        if (!url) { return; }
        if (audio) { scope.pause(); }
        audio = new $window.Audio(url);
        audio.load();
        angular.element(audio)
          .on('canplay', function () {
            scope.canplay = true;
            update();
          })
          .on('ended', function () {
            scope.pause();
          })
          .on('progress', function () {
            if (loading || scope.canplay) { return; }
            scope.$apply(function () {
              loading = true;
              scope.timer = 'loading';
            });
          });
        $timeout(function () {
          scope.timer = scope.timer || 'tap to load';
        }, 300);
      });

      var loading = false;

      scope.tapToClick = function () {
        if (loading || scope.canplay) { return; }
        scope.$apply(function () {
          loading = true;
          scope.timer = 'loading';
        });
        audio.load();
      };

      var interval;

      scope.play = function () {
        if (!audio) { return; }
        audio.play();
        interval = $interval(update, 25, 0, false);
      };

      scope.pause = function () {
        if (!audio) { return; }
        audio.pause();
        $interval.cancel(interval);
        update();
      };

      scope.$on('$destroy', function () {
        scope.pause();
      });

      element.on('$destroy', function () {
        scope.pause();
      });

      var prev;

      function update () {
        var curr = {
          paused: audio.paused,
          progress: (audio.currentTime / audio.duration * 100).toFixed(1),
          timer: timeToString(audio.currentTime) + '/' + timeToString(audio.duration)
        };
        if (!angular.equals(prev, curr)) {
          prev = curr;
          angular.extend(scope, curr);
          if (!scope.$root.$$phase) {
            scope.$digest();
          }
        }
      }

      function timeToString (time) {
        var secs = time >> 0;
        var mins = secs / 60 >> 0;
        return mins + ':' + (secs % 60);
      }

    }
  };
});
